<template>
  <modal-box
    v-if="show_modal"
    width_class="w-full max-w-2xl"
    overflow_body
    v-bind:header="true"
    v-bind:footer="false"
    v-on:close="onclose">
    <template v-slot:modal-header>
      <h1 class="text-3xl font-bold text-core-600">
        {{ `${participant.nom} ${participant.prenom}` }}
        <div
          class="mt-2 w-full border-l-4 pl-3 text-lg font-normal leading-none">
          Convention individuelle
        </div>
      </h1>
    </template>

    <template v-slot:modal-body>
      <div
        class="ressources__download__link__container justify-center"
        v-if="convention_signee">
        <h3 class="ressources__download__link__label py-10">- Convention</h3>
        <div
          class="ressources__download__link__button"
          v-on:click="
            () =>
              download_convention(
                participant.convention.id,
                'validee',
                participant.convention.valideeFileName
              )
          ">
          <div
            class="ressources__standalone_button__content"
            title="Télécharger la convention signée">
            <font-awesome-icon
              class="text-xl"
              icon="download" />
          </div>
        </div>
      </div>

      <div
        class="flex w-full flex-wrap"
        v-else-if="
          !convention_signee && (convention_disponible || convention_uploaded)
        ">
        <div
          class="ressources__download__link__container flex w-full"
          v-if="convention_disponible">
          <h3 class="ressources__download__link__label">
            - Convention à signer
          </h3>
          <div
            class="ressources__download__link__button"
            v-on:click="
              () =>
                download_convention(
                  participant.convention.id,
                  '',
                  participant.convention.fileName
                )
            ">
            <div
              class="ressources__standalone_button__content"
              title="Télécharger la convention à signer">
              <font-awesome-icon
                class="text-xl"
                icon="download" />
            </div>
          </div>
        </div>
        <div
          class="ressources__download__link__container flex w-full"
          v-if="convention_disponible || convention_uploaded">
          <h3 class="ressources__download__link__label">
            - Convention signée
            <span class="text-sm font-normal italic">(par le client)</span>
          </h3>
          <div
            class="ressources__download__link__button"
            v-on:click="
              () =>
                download_convention(
                  participant.convention.id,
                  'signee',
                  participant.convention.signeeFileName
                )
            "
            v-if="
              !participant.convention.signee &&
              participant.convention.fichierSignee
            ">
            <div
              class="ressources__standalone_button__content"
              title="Télécharger la convention téléversée">
              <font-awesome-icon
                class="text-xl"
                icon="download" />
            </div>
          </div>
          <file-upload
            v-if="!participant.convention.signee"
            title="Téléverser la convention signée"
            v-bind:is_file_uploaded="participant.convention.fichierSignee"
            v-bind:upload_url="`${convention_base_url}/${participant.convention.id}/file`"
            v-bind:refresh_session="refresh_session"
            id="convention-individuelle-upload" />
        </div>
      </div>
    </template>

    <template v-slot:modal-footer> </template>
  </modal-box>
</template>
<script>
  import FileUpload from '@/components/utils/file-upload';
  import modalBox from '@/components/utils/modal-box.vue';

  export default {
    components: {
      modalBox,
      FileUpload
    },
    props: {
      show_modal: Boolean,
      participant: Object,
      onclose: Function,
      refresh_session: Function,
      convention_base_url: String,
      download_convention: Function
    },
    data: () => ({ loading: false }),
    computed: {
      convention_disponible() {
        const { convention } = this.participant;

        return convention && convention.id;
      },
      convention_uploaded() {
        const { convention } = this.participant;

        return convention && convention.id && convention.signeeFileName;
      },
      convention_signee() {
        const { convention } = this.participant;

        return (
          convention &&
          convention.id &&
          convention.valideeFileName &&
          convention.signee
        );
      }
    },
    async created() {},
    methods: {
      close() {
        this.detail = null;
        this.onclose();
      }
    }
  };
</script>
<style lang="scss" scoped>
  .ressources__download__link__container {
    @apply mb-3 flex cursor-pointer items-center;

    .ressources__download__link__button {
      @apply ml-3 flex items-center;

      .ressources__download__link__button__content {
        @apply flex h-8 w-full items-center justify-center rounded bg-accent-200 p-4 text-center text-sm font-bold uppercase text-core-500 shadow-md disabled:cursor-not-allowed disabled:opacity-75;
      }
    }

    .ressources__download__link__label {
      @apply ml-8 text-xl font-bold leading-none text-core-700;
    }

    &:hover {
      .ressources__download__link__button {
        .ressources__download__link__button__content {
          @apply bg-accent-300 text-core-600;
        }
      }

      .ressources__download__link__label {
        @apply text-primary-800;
      }
    }
  }
</style>
